"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LogglyContent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("../../../../components/Grid"));

var _ActivationContent = require("./ActivationContent");

var LogglyAnalysis = "https://cdn.solarwinds.cloud/cloud-ui/assets/loggly-analysis-09dcac527aedbcab1680cd9e642fceb9.svg";
var LogglyTroubleshooting = "https://cdn.solarwinds.cloud/cloud-ui/assets/loggly-troubleshoot-3c4af6182100ed3dc0a6ae2f73cdcaea.svg";
var LogglyMonitoring = "https://cdn.solarwinds.cloud/cloud-ui/assets/loggly-monitor-c5c1484e7016d2695835cd5ce54c59c3.svg";
var LogglyLogo = "https://cdn.solarwinds.cloud/cloud-ui/assets/loggly-logo-675cc2acf8c7d95ec2fbf905d0876f06.svg";

var LogglyContent = function LogglyContent(_ref) {
  var productStatus = _ref.productStatus;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductLogo, {
    logo: LogglyLogo
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductDescription, {
    title: "High performance log analysis and monitoring for DevOps"
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: LogglyMonitoring,
    title: "Powerful Log Monitoring",
    content: "Use powerful search, flexible alerts, and dynamic charts and dashboards to monitor applications, system behavior, and unusual activity across the stack. Monitor key resources and metrics and eliminate issues before they affect users."
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: LogglyTroubleshooting,
    title: "Troubleshooting",
    content: "Fast troubleshooting and low MTR. Diagnose issues down to their root case by analyzing them in the context of the entire stack."
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: LogglyAnalysis,
    title: "Data Analysis",
    content: "Granular analysis through Loggly helps DevOps teams drill down into the deepest levels of log visibility to identify performance issues and errors."
  })), /*#__PURE__*/_react["default"].createElement(_ActivationContent.Subscription, {
    productName: "loggly",
    productStatus: productStatus,
    type: _ActivationContent.SUBSCRIPTION_TYPE.TRIAL
  }));
};

exports.LogglyContent = LogglyContent;